/**
 * Labels compartidos para tipos de DTE, formas de pago, tipos de referencia
 * y razones de referencia. Centralización para evitar duplicación entre
 * `FacturarDialog` (tareas), `FacturarManual` (facturación manual) y
 * `PreviewFacturaBorrador`.
 *
 * Códigos según especificación SII Chile.
 */

/**
 * Tipos de DTE soportados por el sistema.
 * 33 = Factura Electrónica afecta a IVA
 * 34 = Factura Electrónica no afecta o exenta
 * 56 = Nota de Débito Electrónica
 * 61 = Nota de Crédito Electrónica
 */
export const TIPO_DTE_LABELS = {
  33: "FACTURA ELECTRÓNICA",
  34: "FACTURA NO AFECTA O EXENTA ELECTRÓNICA",
  56: "NOTA DE DÉBITO ELECTRÓNICA",
  61: "NOTA DE CRÉDITO ELECTRÓNICA",
};

/**
 * Formas de pago del DTE.
 * 1 = Contado
 * 2 = Crédito (default cuando no se especifica explícitamente)
 * 3 = Sin costo (entrega gratuita)
 */
export const FORMATO_PAGO_LABELS = {
  1: "Contado",
  2: "Crédito",
  3: "Sin costo (entrega gratuita)",
};

/**
 * Tipos de documento referenciable en la sección Referencias del DTE.
 * Mismo conjunto que `TIPOS_REFERENCIAS` del formulario de FacturarManual.
 */
export const TIPO_REFERENCIA_LABELS = {
  801: "Orden de compra",
  802: "Nota de pedido",
  803: "Contrato",
  804: "Resolución",
  813: "Pasaporte",
};

/**
 * Razones de referencia (CodRef) para Notas de Crédito y Débito.
 * 1 = Anula documento de referencia
 * 2 = Corrige texto del documento de referencia
 * 3 = Corrige montos del documento de referencia
 *
 * Solo aplica cuando el DTE emisor es 56 (ND) o 61 (NC).
 */
export const COD_REF_LABELS = {
  1: "Anula documento de referencia",
  2: "Corrige texto",
  3: "Corrige montos",
};
